import React, { useState } from 'react';
import { withApollo } from 'react-apollo';
import { Formik } from 'formik';
import { Select, Checkbox } from 'antd';
import Button from '../Button';
import Form from '../Form';
import Input from '../Input';
import { ADD_DELIVERABLE } from './mutation';
import { showError, showSuccess } from '../../notifications';
const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const CopyDeliverableForm = ({
  onComplete,
  client,
  projectId,
  deliverable = {},
  refetchQueries = [],
  milestoneNames = [],
}) => {
  const [createNewMilestone, setCreateNewMilestone] = useState(false);
  
  // Extract fields we want to copy from the original deliverable
  const {
    deliverableName,
    milestoneName,
    budget,
    budgetPercent,
    budgetedHours,
  } = deliverable;

  return (
    <Formik
      initialValues={{
        deliverableName: deliverableName || '',
        milestoneName: milestoneName || '',
        budget: budget || 0,
        budgetPercent: budgetPercent || 0,
        budgetedHours: budgetedHours || 0,
      }}
      validate={values => {
        const errors = {};
        if (!values.deliverableName) {
          errors.deliverableName = 'Required';
        }
        if (!values.milestoneName) {
          errors.milestoneName = 'Required';
        }
        return errors;
      }}
      onSubmit={async (values, { setSubmitting }) => {
        return client
          .mutate({
            mutation: ADD_DELIVERABLE,
            variables: {
              projectId,
              ...values,
            },
            awaitRefetchQueries: true,
            refetchQueries,
          })
          .then(() => {
            setSubmitting(false);
            onComplete();
            showSuccess({ message: `Successfully copied deliverable.` });
          })
          .catch(err => {
            showError({ message: err.message });
            setSubmitting(false);
          });
      }}
    >
      {({ values, errors, touched, isValid, setFieldValue, handleChange, handleSubmit, isSubmitting }) => {
        return (
          <Form onSubmit={handleSubmit} {...formItemLayout}>
            <Form.Item
              label="Deliverable Name"
              hasFeedback
              help={errors.deliverableName || 'You can modify the deliverable name or keep it the same'}
              validateStatus={touched.deliverableName && errors.deliverableName && 'error'}
            >
              <Input name="deliverableName" onChange={handleChange} value={values.deliverableName} />
            </Form.Item>

            <Form.Item label="Category (Milestone)" hasFeedback>
              <Select
                disabled={createNewMilestone}
                name="milestoneName"
                showSearch
                placeholder="Select milestone category"
                optionFilterProp="children"
                value={values.milestoneName}
                onChange={category => {
                  setFieldValue('milestoneName', category);
                }}
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {milestoneNames &&
                  milestoneNames.map(name => {
                    return (
                      <Option value={name} key={name}>
                        {name}
                      </Option>
                    );
                  })}
              </Select>
              <Checkbox 
                checked={createNewMilestone} 
                onChange={e => setCreateNewMilestone(e.target.checked)}
              >
                Create New Milestone
              </Checkbox>
            </Form.Item>

            {createNewMilestone && (
              <Form.Item
                label="New Milestone Name"
                hasFeedback
                help={errors.milestoneName || 'Enter a new milestone category name'}
              >
                <Input name="milestoneName" onChange={handleChange} value={values.milestoneName} />
              </Form.Item>
            )}

            <div className="flex justify-end gap-2">
              <Button onClick={onComplete}>
                Cancel
              </Button>
              <Button loading={isSubmitting} type="primary" htmlType="submit">
                Copy Deliverable
              </Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default withApollo(CopyDeliverableForm);

